import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { GmailPage } from '~/features/connectors/gmail-page';

/**
 * Google's way back (docs/plans/connectors-gmail.md, Decided 3): `connected=1`,
 * or `error=failed` or `error=cancelled`. The router reads each value as JSON,
 * so `connected=1` arrives as a number.
 */
const search = z.object({
  connected: z.union([z.number(), z.string()]).optional(),
  error: z.string().optional(),
});

function GmailRoute(): ReactElement {
  const found = Route.useSearch();
  return <GmailPage search={found} />;
}

/** The viewer's Gmail: its rules, the emails waiting for a yes, and what OS sent (boards C4, C6, C7). */
export const Route = createFileRoute('/_app/business/connectors/gmail/')({
  validateSearch: search,
  component: GmailRoute,
});
